import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTopSmall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-top-small"><path fillRule="evenodd" clipRule="evenodd" d="M12 11.0606L15.4697 14.5303C15.7626 14.8231 16.2374 14.8231 16.5303 14.5303C16.8232 14.2374 16.8232 13.7625 16.5303 13.4696L12.8839 9.82315C12.3957 9.33499 11.6043 9.33499 11.1161 9.82315L7.46967 13.4696C7.17678 13.7625 7.17678 14.2374 7.46967 14.5303C7.76256 14.8231 8.23744 14.8231 8.53033 14.5303L12 11.0606Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTopSmall;
